document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-rl-carousel]').forEach((root) => {
    const track = root.querySelector('[data-rl-track]');
    if (!track) return;
    const step = () => Math.min(track.clientWidth * 0.85, 224 * 3);
    root.querySelector('[data-rl-prev]')?.addEventListener('click', () => {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    root.querySelector('[data-rl-next]')?.addEventListener('click', () => {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
  });
});
